import { table1, table2, table3, table4, table5 } from "./tables";


export const comparision = [
{
  title: "Oyster Vs Copy.AI"  ,
  para:"Compare Oyster with Copy.AI to decide the best AI writer and copywriting software for your need.",
  button:"View Comparison",
  table: table1,
},
{
    title: "Oyster vs. Writesonic "  ,
    para:"Compare Oyster with Writesonic to decide the best AI writer and copywriting software for your need.",
    button:"View Comparison",
    table: table2,

  },
  {
    title: "Oyster vs. Peppertype "  ,
    para:"Compare Oyster with Peppertype to decide the best AI writer and copywriting software for your need.",
    button:"View Comparison",
    table: table3,

  },
  {
    title: "Oyster vs. ChatGPT "  ,
    para:"Compare Oyster with ChatGPT to decide the best AI writer and copywriting software for your need.",
    button:"View Comparison",
    table: table4,

  },
  {
    title: "Oyster vs. Grammarly "  ,
    para:"Compare Oyster with Grammarly to decide the best AI writer and copywriting software for your need.",
    button:"View Comparison",
    table: table5,

  },
  
]